import React, { PureComponent } from 'react';
import styled, { css } from 'styled-components';
import { hover, bp } from 'Styles/helpers';
import screen from 'superior-mq';
import { rem } from 'polished';
import { Formik, Form } from 'formik';
import subscription from '../../../lib/subscription';
import Button from '../../button';

export default class Subscribe extends PureComponent {

  state = {
    subscribeStatus: null,
  };

  handleSubmit = ({ email }) => {
    subscription(email)
      .then((response) => {
        if (response.id) {
          this.setState({ subscribeStatus: 'subscribed' });
        }
      });
  }

  render() {
    return (
      <FormWrap>
        <Formik
          initialValues={{ email: '' }}
          validate={(values) => {
            const errors = {};

            if (!values.email) {
              errors.email = 'Email is required';
            } else if (
              !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
            ) {
              errors.email = 'Invalid email address';
            }

            return errors;
          }}
          onSubmit={this.handleSubmit}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            isSubmitting,
          }) => (
            <SubscribeForm
              id="mc-embedded-subscribe-form"
              name="mc-embedded-subscribe-form"
              className="validate"
            >
              <label htmlFor="subscribe-input">Subscribe for updates</label>
              <SubscribeInput
                type="email"
                name="email"
                placeholder="Your Email"
                id="mce-EMAIL"
                required
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.EMAIL}
              />
              <div style={{ position: 'absolute', left: '-5000px' }} aria-hidden="true">
                <input type="text" name="b_a999b8113a4c8a0893311771d_b61d89545e" tabIndex="-1" defaultValue="" />
              </div>
              {(errors.email && touched.email &&
                <FormErr>{errors.email}</FormErr>
              ) || (this.state.subscribeStatus && this.state.subscribeStatus === 'subscribed' &&
                <FormSuccess>Successfully subscribed</FormSuccess>
              )}
              <Signup
                type="submit"
                disabled={isSubmitting}
                value="Subscribe"
                name="submit"
                id="mc-embedded-subscribe"
              >
                Sign Up
              </Signup>
            </SubscribeForm>
          )}
        </Formik>
      </FormWrap>
    );
  }
}

const FormWrap = styled.div`
  max-width: 900px;
  margin: 25px auto 60px;
  padding: 50px 40px;
  background-color: ${props => props.theme.lightGray};

  ${screen.below(bp.mobile, `
    padding: 30px 20px;
    margin: 20px auto 30px;
  `)}
`;

const SubscribeForm = styled(Form)`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  position: relative;
  max-width: 648px;
  margin: auto;
  border: 4px solid ${props => props.theme.blue};

  label {
    position: absolute;
    left: -9999px;
    opacity: 0;
    pointer-events: none;
  }

  ${screen.below(bp.mobile, `
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    border-width: 2px;
  `)}
`;

const SubscribeInput = styled.input`
  width: 100%;
  appearance: none;
  border: 0;
  font-size: 1rem;
  font-family: inherit;
  line-height: 1;
  padding: 0 1rem;
  background-color: transparent;
  grid-column: 1 / span 2;
  border-right: 4px solid ${props => props.theme.blue};
  border-radius: 0;
  margin: 0;

  &:-webkit-autofill,
  &:-internal-autofill-selected {
    /* stylelint-disable property-no-vendor-prefix */
    -webkit-box-shadow: 0 0 0 1000px ${props => props.theme.lightGray} inset !important;
    -webkit-text-fill-color: ${props => props.theme.black} !important;
    /* stylelint-enable */
  }

  ${screen.below(bp.mobile, `
    padding: 14px;
    border-right-width: 2px;
  `)}
`;

const Signup = styled(Button)`
  background-color: transparent;
  width: calc(100% + 1px);
  padding: 0 60px;
  color: ${props => props.theme.black};
  font-size: 1rem;
  line-height: 58px;
  outline: none;
  grid-column: 3 / -1;
  margin: 0;

  &:focus {
    color: #fff;
    background-color: ${props => props.theme.blue};
  }

  ${screen.below(bp.mobile, `
    padding: 0 30px;
  `)};

  ${screen.below(bp.mobileSm, `
    padding: 0 15px;
    font-size: ${rem(11)};
    line-height: 42px;
    min-width: 0;
  `)}

  ${css`
    :not(:disabled) {
      ${props => hover(`
        color: #fff;
        background-color: ${props.theme.blue};
      `)}
    }
  `}
`;

const FormErr = styled.div`
  position: absolute;
  top: calc(100% + 10px);
  right: 0;
  left: 0;
  font-size: ${rem(14)};
  font-weight: 600;
  text-align: center;
  color: ${props => props.theme.error};
`;

const FormSuccess = styled.div`
  position: absolute;
  top: calc(100% + 10px);
  right: 0;
  left: 0;
  font-size: ${rem(14)};
  font-weight: 600;
  text-align: center;
  color: ${props => props.theme.success};
`;
